module.exports = __webpack_public_path__ + "static/media/vic-logo.1f9c7e89.svg";